// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__T66Sx","tab":"ProcedureTabs_tab__3MPJE"};